import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import ImageUploadField from "../../../utils/ImageUploadField";
import { confirmDelete, successToast, errorToast } from "../../../utils/dialog";

const FamilyLegacyAdmin = () => {
  const { familyLegacyData, updateFamilyLegacy, deleteFamilyLegacy } = useData();

  const [formData, setFormData] = useState({
    timeline: familyLegacyData.timeline || ["1991", "2002", "2012", "Present"],
    image: familyLegacyData.image || "",
    heading: familyLegacyData.heading || "",
    description: familyLegacyData.description || "",
  });
  const [imageFile, setImageFile] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTimelineChange = (index, value) => {
    const updatedTimeline = [...formData.timeline];
    updatedTimeline[index] = value;
    setFormData((prev) => ({ ...prev, timeline: updatedTimeline }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const previewUrl = URL.createObjectURL(file);
      setFormData((prev) => ({ ...prev, image: previewUrl }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateFamilyLegacy(formData, imageFile);
      successToast("Family Legacy section updated.");
    } catch (err) {
      console.error(err);
      errorToast("Error updating Family Legacy section.");
    }
  };

  const handleDelete = async () => {
    if (
      await confirmDelete({
        title: "Delete section?",
        text: "This Family Legacy section will be permanently removed.",
      })
    ) {
      try {
        await deleteFamilyLegacy();
        successToast("Family Legacy section deleted.");
      } catch (err) {
        console.error(err);
        errorToast("Error deleting Family Legacy section.");
      }
    }
  };

  return (
    <div className="p-6 space-y-8">
      <h2 className="text-3xl font-bold mb-4 text-gray-800">Family Legacy Admin Panel</h2>

      {/* Form */}
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
        <h3 className="text-2xl font-semibold text-gray-700 mb-4">Update Section</h3>
        <ImageUploadField
          label="Image"
          hint="Recommended size: 800×600px"
          aspect="4/3"
          previewUrl={formData.image}
          file={imageFile}
          onChange={handleFileChange}
          onClear={() => {
            setImageFile(null);
            setFormData((prev) => ({ ...prev, image: "" }));
          }}
        />

        <div className="flex justify-end space-x-4">
          <button
            type="submit"
            className="px-6 py-2 bg-[#14251F] hover:bg-[#1f3a30] text-[#FFD1A0] rounded transition font-medium"
          >
            Update Section
          </button>
          <button
            type="button"
            onClick={handleDelete}
            className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white rounded transition"
          >
            Delete Section
          </button>
        </div>
      </form>
    </div>
  );
};

export default FamilyLegacyAdmin;